import { MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react'
import type { LegalDoc } from '../../types/legal'

/** PLACEHOLDER — timeframes and escalation steps require compliance review. */
export const complaintsPolicy: LegalDoc = {
  slug: 'complaints',
  title: 'Complaints & dispute resolution',
  lastUpdated: '[date]',
  version: '[x.x]',
  summary: [
    'Contact us by phone, email, WhatsApp, or at our Kigali office.',
    'We acknowledge every complaint within [timeframe to confirm].',
    'We aim to send a full response within [timeframe to confirm].',
    'If you are not satisfied, you can escalate to the regulator.',
  ],
  sections: [
    {
      id: 'how-it-works',
      title: 'How the process works',
      blocks: [
        {
          type: 'steps',
          items: [
            {
              title: 'Contact us',
              text: 'Tell us what happened using any channel below. Include your account details and any receipts.',
              timeframe: 'Any time',
            },
            {
              title: 'We acknowledge',
              text: 'We confirm we’ve received your complaint and give you a reference number.',
              timeframe: '[Within X days]',
            },
            {
              title: 'We investigate and respond',
              text: 'We look into the issue and send you a written response with our outcome.',
              timeframe: '[Within X days]',
            },
            {
              title: 'Escalation',
              text: 'If you’re not satisfied with our response, you can escalate your complaint.',
              timeframe: '[After X days]',
            },
          ],
        },
      ],
    },
    {
      id: 'contact-channels',
      title: 'Contact channels',
      blocks: [
        {
          type: 'contacts',
          items: [
            { icon: PhoneIcon, label: 'Phone', value: '[phone number]' },
            { icon: MailIcon, label: 'Email', value: '[complaints email]' },
            { icon: MessageCircleIcon, label: 'WhatsApp', value: '[WhatsApp number]' },
            { icon: MapPinIcon, label: 'Office visit', value: '57A KG 215 St, Kigali · [opening hours]' },
          ],
        },
        { type: 'action', label: 'Submit a complaint', href: '/contact' },
      ],
    },
    {
      id: 'what-to-include',
      title: 'What to include',
      blocks: [
        {
          type: 'list',
          items: [
            '[Placeholder] Your name and business name.',
            '[Placeholder] The phone number or email on your Kayko account.',
            '[Placeholder] Date, amount, and reference of any transaction involved.',
            '[Placeholder] What outcome you are asking for.',
          ],
        },
      ],
    },
    {
      id: 'escalation',
      title: 'Escalating to the regulator',
      blocks: [
        {
          type: 'callout',
          tone: 'warning',
          title: 'Placeholder for compliance review',
          text: 'This section must be written and approved by Compliance before publishing.',
        },
        {
          type: 'paragraph',
          text: '[Placeholder] Explain when and how a customer may refer an unresolved complaint to the National Bank of Rwanda, including contact details and any time limits [to confirm].',
        },
      ],
    },
    {
      id: 'business-finance-complaints',
      title: 'Business Financing complaints',
      blocks: [
        {
          type: 'paragraph',
          text: '[Placeholder] Explain how complaints about financing provided by Mula Financial Services Ltd are handled and passed on.',
        },
      ],
    },
  ],
}
